
if (window.matchMedia("(max-width: 768px)").matches) {
let footerBlockH2s = document.querySelectorAll('footer .footer__block--menu h2');
footerBlockH2s.forEach(h2 => {
    h2.addEventListener('click', (e) => {
        let nextDiv = e.target.nextElementSibling;
        e.currentTarget.parentNode.classList.add('active')
        let divs = document.querySelectorAll('footer .footer__quicklinks');
        if(divs.length > 0) {
            divs.forEach(div => {
                if(div !== nextDiv) {
                    div.parentNode.classList.remove('active')
                }
            });
        }
    });
});
}

//modal Geolocation
 // Get the modal
 var modal = document.getElementById("modal_geolocation");
 // Get the <span> element that closes the modal
 var span = document.getElementsByClassName("geolocation_close")[0];
 // When the user clicks on the button, open the modal
 openModalGeolocation = function () {
   modal.style.display = "block";
 }
 // When the user clicks on <span> (x), close the modal
 span.onclick = function () {
   modal.style.display = "none";
 }
 // When the user clicks anywhere outside of the modal, close it
 window.onclick = function (event) {
   if (event.target == modal) {
     modal.style.display = "none";
   }
 }

 // add event function to close select on click
function closeSelect(){
    document.querySelector('#details_contact-form').removeAttribute('open');
    document.querySelector('#details_contact-form2').removeAttribute('open');
}

const inputCountries = document.querySelectorAll('.redirect-stores-SP');
if (inputCountries.length > 0 ) {
  inputCountries.forEach(country => {
    country.addEventListener('click', e => {
      switch (e.target.value) {
        case 'FR':
          window.location.href = "https://www.simone-perele.com/fr-fr/";
          break;
        case 'AU':
          window.location.href = "https://www.simone-perele.com.au/";
          break;
        case 'BE':
          window.location.href = "https://www.simone-perele.com/fr-be/";
          break;
        case 'LU':
          window.location.href = "https://www.simone-perele.com/fr-be/";
          break;
        case 'NL':
          window.location.href = "https://www.simone-perele.com/nl-be/";
          break;
        case 'SK':
          window.location.href = "https://www.simoneperele.sk/";
          break;
        case 'CZ':
          window.location.href = "https://www.simoneperele.cz/";
          break;
        case 'NZ':
          window.location.href = "https://www.simone-perele.com/en-int/";
          break;
        case 'GB':
          window.location.href = "https://www.simone-perele.com/en-gb/";
          break;
        default:
          break;
      }
    });
  });
}
